module.exports = __webpack_public_path__ + "static/NHaasGroteskDSStd-95Blk-3e7fc3a958e7726b2c3c60509aa00703.woff";